
  <div class="header">
      <img priority="5" ngSrc="{{ image }}" height="128" width="239" alt="auth form image" />
      <span>{{ title }}</span>
  </div>
  <div class="steps">
      <!-- ------------------------------------------------------------ EMAIL ------------------------------ -->
      <div *ngIf="emailStepState == 'active'"
              class="step">
          <div class="title">
              <div *ngIf="isIHaveAnAccountText">{{ 'Connection' | translate }}</div>
              <div *ngIf="isIHaveAnAccountText" class="sub"></div>
              <div *ngIf="!isIHaveAnAccountText">{{ 'Registration' | translate }}</div>
              <div *ngIf="!isIHaveAnAccountText" class="sub">{{ 'Create_your_x_account' | translate:{platformName:conf.platformName} }}</div>
          </div>
          <div class="input">
              <mat-form-field color="accent"
                              [hintLabel]="'Use_your_x_account' | translate:{platformName:conf.platformName}">
                  <input #emailControl
                       matInput
                       maxlength="255"
                       placeholder="{{ 'Email_address' | translate }}"
                       type="email"
                       (keyup.enter)="onCheckEmailClicked($event)"
                       [formControl]="emailFormControl" />
                  <mat-icon matPrefix>mail_outline</mat-icon>
                  <mat-error *ngIf="emailFormControl.hasError('email')">{{ 'Email_invalid' | translate }}</mat-error>
              </mat-form-field>
          </div>
          <div class="actions">
              <button mat-raised-button
                      color="accent"
                      [disabled]="isLoading || emailFormControl.hasError('email') || emailFormControl.hasError('required') ? '':null"
                      (click)="onCheckEmailClicked($event)">
                  {{ 'Next' | translate }}
              </button>
              <ng-container *ngIf="!isRegistrationDisabled">
                  <button *ngIf="isIHaveAnAccountText"
                          mat-button
                          class="link"
                          color="accent"
                          [disabled]="isLoading"
                          (click)="onNoAccountClicked()">
                      {{ 'I_dont_have_an_account' | translate }}
                  </button>
                  <button *ngIf="!isIHaveAnAccountText"
                          mat-button
                          class="link"
                          color="accent"
                          [disabled]="isLoading"
                          (click)="onUseAccountClicked()">
                      {{ 'I_have_an_account' | translate }}
                  </button>
              </ng-container>
          </div>
      </div>
      <!-- ------------------------------------------------------------ PASSWORD ------------------------------ -->
      <div *ngIf="passwordStepState == 'active'"
              class="step">
          <div class="title">
              <div>{{ 'Welcome' | translate }}</div>
              <div class="sub link" (click)="onNotYouClicked()"><mat-icon>arrow_back</mat-icon>{{ email }}</div>
          </div>
          <div class="input">
              <mat-form-field *ngIf="!currentUser.isLoggedIn()" color="accent">
                  <input #passwordControl
                          matInput
                          maxlength="255"
                          placeholder="{{ 'Password' | translate }}"
                          (keyup)="onPasswordKeyPressed()"
                          (keyup.enter)="onCheckPasswordClicked($event)"
                          [formControl]="passwordFormControl"
                          [(ngModel)]="password"
                          type="{{ isChecked ? 'text' : 'password' }}" />
                  <mat-icon matPrefix>lock_outline</mat-icon>
                  <mat-icon matSuffix class="show-password" (click)="toggleFieldType()">{{ isChecked ? 'visibility_off' : 'visibility' }}</mat-icon>
                  <mat-error *ngIf="passwordFormControl.hasError('required')">{{ 'Password_required' | translate }}</mat-error>
                  <mat-error *ngIf="passwordFormControl.hasError('passwordWrong')">{{ 'Password_wrong' | translate }}</mat-error>
                  <mat-error *ngIf="passwordFormControl.hasError('accountDisabled')">{{ 'Account_disabled' | translate }}</mat-error>
              </mat-form-field>
              <div>
                  <mat-checkbox [(ngModel)]="rememberMe" color="primary">{{ 'Remember_me' | translate }}</mat-checkbox>
                 <mat-checkbox #eulaControl
                               [formControl]="eulaFormControl"
                               [(ngModel)]="eulaAccepted"
                               (change)="onEulaChanged($event)"
                               color="primary" class="eula-checkbox">{{ 'EULA_accept' | translate }}<a href="/eula-terms" target="_blank">{{ "EULA_terms_link" | translate }}</a>.</mat-checkbox>
                 <mat-error *ngIf="eulaFormControl.hasError('eulaNotAccepted')">{{ 'EULA_required' | translate }}</mat-error>
              </div>
          </div>
          <div class="actions">
              <button mat-raised-button
                      color="accent"
                      [disabled]="isLoading || passwordFormControl.hasError('required') || passwordFormControl.hasError('passwordWrong') || !this.eulaAccepted ? '':null"
                      (click)="onCheckPasswordClicked($event)">
                  {{ 'Next' | translate }}
              </button>
              <button mat-button
                      class="link"
                      color="accent"
                      [disabled]="isLoading"
                      (click)="onForgotPasswordClicked()">
                  {{ 'Forgot_password' | translate }} ?
              </button>
          </div>
      </div>
      <!-- ------------------------------------------------------------ UNAUTHORIZED ------------------------------ -->
      <div *ngIf="unauthorizedStepState == 'active'"
              class="step">
          <div class="title">
              <div>:-(</div>
              <div class="sub">{{ 'You_are_not_authorized_here' | translate }}</div>
          </div>
          <div class="actions">
              <button mat-raised-button
                      color="accent"
                      [disabled]="isLoading"
                      (click)="onNotYouClicked()">
                  {{ 'Back' | translate }}
              </button>
          </div>
      </div>        <!-- ------------------------------------------------------------ FORGOT PASSWORD ------------------------------ -->
      <div *ngIf="forgotPasswordState == 'active'"
              class="step">
          <div class="title">
              <div>{{ 'Recover_password' | translate }}</div>
              <div class="sub">{{ 'Instructions_to_renew_password_sent' | translate:{email: email} }}</div>
          </div>
          <div class="actions">
              <button mat-raised-button
                      color="accent"
                      [disabled]="isLoading"
                      (click)="onNotYouClicked()">
                  {{ 'Ok' | translate }}
              </button>
          </div>
      </div>        <!-- ------------------------------------------------------------ RESET PASSWORD ------------------------------ -->
      <div *ngIf="resetPasswordState == 'active'"
              class="step">
          <div class="title">
              <div>{{ 'Reset_password' | translate }}</div>
              <div class="sub">{{ email }}</div>
          </div>
          <div class="input">
              <mat-form-field *ngIf="!currentUser.isLoggedIn()" color="accent">
                  <input #resetPasswordControl
                          matInput
                          maxlength="255"
                          placeholder="{{ 'New_password' | translate }}"
                          (keyup.enter)="onResetPasswordClicked($event)"
                          [formControl]="resetPasswordFormControl"
                          [(ngModel)]="newPassword"
                          autocomplete="off"
                          type="password" />
                  <span matPrefix><mat-icon>lock_outline</mat-icon> &nbsp;</span>
                  <mat-hint>{{ 'New_password_hint' | translate }}</mat-hint>
                  <mat-error *ngIf="resetPasswordFormControl.hasError('required')">{{ 'Password_required' | translate }}</mat-error>
                  <mat-error *ngIf="resetPasswordFormControl.hasError('minlength')">{{ 'Password_too_short' | translate:{length: PASSWORD_MIN_LENGTH} }}</mat-error>
              </mat-form-field>
          </div>
          <div class="actions">
              <button mat-raised-button
                      color="accent"
                      [disabled]="isLoading || resetPasswordFormControl.hasError('required') || resetPasswordFormControl.hasError('minlength') ? '':null"
                      (click)="onResetPasswordClicked($event)">
                  {{ 'Reset' | translate }}
              </button>
          </div>
      </div>        <!-- ------------------------------------------------------------ REGISTER ------------------------------ -->
      <div *ngIf="registerStepState == 'active'"
              class="step">
          <div class="title">
              <div>{{ 'Registration' | translate }}</div>
              <div class="sub link" (click)="onNotYouClicked()">{{ email }}</div>
          </div>
          <div class="input">
              <div class="in-line">
                  <mat-form-field color="accent">
                      <input #registerFirstNameControl
                              matInput
                              maxlength="255"
                              placeholder="{{ 'First_name' | translate }}"
                              (keyup.enter)="onCheckRegisterClicked($event)"
                              [formControl]="registerFirstNameFormControl"
                              [(ngModel)]="registerFirstName"
                              type="text" />
                      <span matPrefix><mat-icon>perm_identity</mat-icon> &nbsp;</span>
                      <mat-error *ngIf="registerFirstNameFormControl.hasError('required')">{{ 'First_name_required' | translate }}</mat-error>
                  </mat-form-field>
                  <mat-form-field color="accent">
                      <input #registerLastNameControl
                              matInput
                              maxlength="255"
                              placeholder="{{ 'Last_name' | translate }}"
                              (keyup.enter)="onCheckRegisterClicked($event)"
                              [formControl]="registerLastNameFormControl"
                              [(ngModel)]="registerLastName"
                              type="text" />
                      <mat-error *ngIf="registerLastNameFormControl.hasError('required')">{{ 'Last_name_required' | translate }}</mat-error>
                  </mat-form-field>
              </div>
              <mat-form-field *ngIf="!currentUser.isLoggedIn()" color="accent">
                  <input #registerPasswordControl
                          matInput
                          maxlength="255"
                          placeholder="{{ 'Password' | translate }}"
                          (keyup.enter)="onCheckRegisterClicked($event)"
                          [formControl]="registerPasswordFormControl"
                          [(ngModel)]="registerPassword"
                          autocomplete="off"
                          type="password" />
                  <span matPrefix><mat-icon>lock_outline</mat-icon> &nbsp;</span>
                  <mat-hint>{{ 'New_password_hint' | translate }}</mat-hint>
                  <mat-error *ngIf="registerPasswordFormControl.hasError('required')">{{ 'Password_required' | translate }}</mat-error>
                  <mat-error *ngIf="registerPasswordFormControl.hasError('minlength')">{{ 'Password_too_short' | translate:{length: PASSWORD_MIN_LENGTH} }}</mat-error>
              </mat-form-field>
              <div class="remember-box">
                  <mat-checkbox [(ngModel)]="rememberMe" color="primary">{{ 'Remember_me' | translate }}</mat-checkbox>
              </div>
          </div>
          <div class="actions">
              <button mat-raised-button
                      color="accent"
                      [disabled]="isLoading
                      || registerPasswordFormControl.hasError('required')
                      || registerPasswordFormControl.hasError('minlength')
                      || registerFirstNameFormControl.hasError('required')
                      || registerLastNameFormControl.hasError('required') ?
                          '' : null"
                      (click)="onCheckRegisterClicked($event)">
                  {{ 'Next' | translate }}
              </button>
          </div>
      </div>
  </div>
  <div class="progress-container">
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
